import { render, staticRenderFns } from "./kyc-video-katoon.vue?vue&type=template&id=76333922&scoped=true"
import script from "./kyc-video-katoon.vue?vue&type=script&lang=js"
export * from "./kyc-video-katoon.vue?vue&type=script&lang=js"
import style0 from "./kyc-video-katoon.vue?vue&type=style&index=0&id=76333922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76333922",
  null
  
)

export default component.exports